const BASE_URL = process.env.REACT_APP_API_URL || "https://app.3devsnet.com/api/routes";

export default BASE_URL;


//Hostinger: https://app.3devsnet.com/api/routes
//Local: http://localhost:3001/routes

//local: cd backend/ php -c "C:\php\php.ini" -S localhost:3001



//usuario completo: admin_3devs  @3devs2026
//usuario simple: admin_balto    @Cr3devs2026


